import React from 'react';
import { Link } from 'react-router';

// August 7th: refactored for responsiveness
const Footer = () => {
    return (
        <div className="w3-content d-flex flex-row hind font-10 p-2">
            <span className=" margin-right align-self-center w3-hide-small">@ 2023 Challenge Sports</span>
            <span className=" margin-right align-self-center w3-hide-small">|</span>
            <span className=" margin-right align-self-center w3-hide-small">All Rights Reserved</span>
            <span className=" margin-right align-self-center w3-hide-small">|</span>
            <Link to="/privacy" className=" margin-right align-self-center white">Privacy Policy</Link>
            <span className=" margin-right align-self-center w3-hide-small">|</span>
            <Link to="/admin" className=" margin-right align-self-center white w3-hide-small">Admin</Link>
            <span className=" ml-auto margin-right align-self-center">FOLLOW US</span>
            <a href="https://www.facebook.com/ChallengeSports3v3?sk=wall" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook margin-right align-self-center white" /></a>
            <a href="https://twitter.com/challsports" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter margin-right align-self-center white" /></a>
            <a href="https://www.instagram.com/challengesports" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram align-self-center white" /></a>
        </div>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layouts/footer.js